import { IViewModelLifecycle } from "./IViewModelLifecycle.types";
import { IViewModelListeners } from "./IViewModelListeners.types";
import { IReactionDisposer } from "mobx";
// import { IRepositoryLifecycle } from "~domain/repositories/__types__";

export abstract class IViewModel
  implements IViewModelLifecycle, IViewModelListeners
{
  public abstract reactions?: { [key: string]: IReactionDisposer } | undefined;

  // public abstract repositories?: {
  //   [key: string]: IRepositoryLifecycle;
  // };

  /**
   * Method should be called when view model is destroying. Here we should clear
   * all subscriptions, mobx reactions, times, etc. to prevent memory leaks and
   * unhandled actions. Please make sure that you called this method at place where
   * it will be used.
   *
   * Please note that method not will be called automatically. You should call this
   * method from place of usage when it will be needed.
   */
  public abstract beforeDestroy(): void;
}
